import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  doc,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "@/lib/firebase/config";

// ─── Types ────────────────────────────────────────────────────────────────────

export interface EnquiryPayload {
  name: string;
  email: string;
  phone?: string;
  subject: string;
  message: string;
}

export interface Enquiry extends EnquiryPayload {
  id: string;
  read: boolean;
  createdAt: unknown;
}

// ─── Public: submit enquiry ───────────────────────────────────────────────────

export async function createEnquiry(data: EnquiryPayload): Promise<void> {
  await addDoc(collection(db, "enquiries"), {
    ...data,
    read: false,
    createdAt: serverTimestamp(),
  });
}

// ─── Admin: fetch all enquiries ───────────────────────────────────────────────

export async function getEnquiries(): Promise<Enquiry[]> {
  const q = query(collection(db, "enquiries"), orderBy("createdAt", "desc"));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({ id: d.id, ...d.data() }) as Enquiry);
}

// ─── Admin: mark as read ──────────────────────────────────────────────────────

export async function markEnquiryRead(id: string): Promise<void> {
  await updateDoc(doc(db, "enquiries", id), { read: true });
}

// ─── Admin: mark as unread ────────────────────────────────────────────────────

export async function markEnquiryUnread(id: string): Promise<void> {
  await updateDoc(doc(db, "enquiries", id), { read: false });
}